// Port of api/fuel/app/classes/insights/shelf/overview.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'

export default Segment.extend({
	name: 'overview',
	insight: false,
	detail: false,
	requires: ['activity', 'longest'],
	run: function() {
		var overview = {
			currentSize: 0,
			averageSize: 0,
			currentPercent: 0,
			averagePercent: 0,
			totalCurrent: 0,
			highestSize: { value: 0, month: '' },
			highestPercent: { value: 0, month: '' },
			lowestSize: { value: null, month: '' },
			lowestPercent: { value: null, month: '' },
			averageCurrent: 0,
			averageAll: 0,
			unplayed: 0
		}

		var activity = this._data.activity || []
		var longest = this._data.longest || []

		if (activity.length) {
			overview.currentSize = activity[activity.length - 1].size
			overview.currentPercent = activity[activity.length - 1].percent
		}

		var currentDays = 0
		var currentCount = 0
		var allDays = 0
		var allCount = 0

		for (var i = 0; i < longest.length; i++) {
			var item = longest[i]
			if (item.to) {
				allDays += item.length
				allCount++
			} else {
				currentDays += item.length
				currentCount++
			}
			if (!item.played && item.to) overview.unplayed++
		}

		for (var j = 0; j < activity.length; j++) {
			var month = activity[j]
			var monthLabel = new Date(month.unix * 1000).toLocaleString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' })

			if (month.size >= overview.highestSize.value) {
				overview.highestSize.value = month.size
				overview.highestSize.month = monthLabel
			}
			if (month.percent >= overview.highestPercent.value) {
				overview.highestPercent.value = month.percent
				overview.highestPercent.month = monthLabel
			}
			if (overview.lowestSize.value === null || month.size <= overview.lowestSize.value) {
				overview.lowestSize.value = month.size
				overview.lowestSize.month = monthLabel
			}
			if (overview.lowestPercent.value === null || month.percent <= overview.lowestPercent.value) {
				overview.lowestPercent.value = month.percent
				overview.lowestPercent.month = monthLabel
			}

			overview.averageSize += month.size
			overview.averagePercent += month.percent
		}

		if (currentCount) overview.averageCurrent = Math.round((currentDays / currentCount) / Constants.TIME_DAY * 10) / 10
		if (allCount) overview.averageAll = Math.round((allDays / allCount) / Constants.TIME_DAY * 10) / 10

		overview.totalCurrent = Math.round(currentDays / Constants.TIME_DAY)
		if (activity.length) {
			overview.averageSize = Math.round(overview.averageSize / activity.length)
			overview.averagePercent = Math.round(overview.averagePercent / activity.length)
		}

		return {
			overview: overview
		}
	}
})
